<p-card class="w-full p-2 m-4 md:w-6/12">
  <ng-template #title> Payment History </ng-template>
  <div *ngIf="!hasPayments">No payments found</div>
  <table *ngIf="this.hasPayments">
    <thead>
      <tr>
        <th>Date</th>
        <th>Status</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of customer_overview()?.payments?.data">
        <td>{{item.payment_date * 1000 | date}}</td>
        <td>{{item.payment_status}}</td>
        <td>{{item.payment_total | currency: 'USD'}}</td>
      </tr>
    </tbody>
  </table>
</p-card>
 